// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGRecord = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#record__clip0_12_2584)",
    children: [/*#__PURE__*/_jsx("mask", {
      id: "record__a",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 32,
      children: /*#__PURE__*/_jsx("g", {
        clipPath: "url(#record__clip1_12_2584)",
        children: /*#__PURE__*/_jsxs("g", {
          clipPath: "url(#record__clip2_12_2584)",
          children: [/*#__PURE__*/_jsx("path", {
            d: "M25.429 12.858c.628 0 1.142.514 1.142 1.142 0 5.283-4.01 9.65-9.142 10.22V30H22c.629 0 1.143.515 1.143 1.143 0 .629-.514 1.143-1.143 1.143H10.571c-.628 0-1.142-.514-1.142-1.143 0-.628.514-1.143 1.142-1.143h4.572v-5.78C10.01 23.65 6 19.283 6 14c0-.628.514-1.142 1.143-1.142.628 0 1.143.514 1.143 1.142 0 4.412 3.588 8 8 8 4.411 0 8-3.588 8-8 0-.628.514-1.142 1.143-1.142z"
          }), /*#__PURE__*/_jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.286.286C19.44.286 22 2.846 22 6v8c0 3.155-2.56 5.715-5.714 5.715-3.155 0-5.715-2.56-5.715-5.715V6c0-3.154 2.56-5.714 5.715-5.714zm0 2.286c-1.886 0-3.429 1.543-3.429 3.428v8c0 1.886 1.543 3.429 3.429 3.429 1.885 0 3.428-1.543 3.428-3.429V6c0-1.885-1.543-3.428-3.428-3.428z"
          })]
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#record__a)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0V0z"
      })
    })]
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsx("clipPath", {
      id: "record__clip0_12_2584",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "record__clip1_12_2584",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "record__clip2_12_2584",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    })]
  })]
}));
SVGRecord.displayName = 'SVGRecord';
export default SVGRecord;